import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "carbonCredits",
  initialState: {
    list: [],
    count: 0,
  },
  reducers: {
    setCarbonCredits: (state, { payload: list }) => ({ ...state, list }),
    countCarbonCredits: (state, { payload: count }) => ({ ...state, count }),
  },
});

export const { setCarbonCredits, countCarbonCredits } = slice.actions;
export default slice.reducer;

export const getCarbonCreditsSelector = (store) => store.carbonCredits.list;
export const getCarbonCreditsCountSelector = (store) => store.carbonCredits.count;